<template>
<div class="drawerWrap devDetailDW">
  <div class="drawerBody detailsDrawerBody">
    <div class="basic detailsItem">
      <h4>基本信息</h4>
      <div class="details">
        <ul>
          <li>
            <div class="label">设备名称:</div>
            <div class="value">{{datailsData.name}}</div>
          </li>
          <li>
            <div class="label">设备ID:</div>
            <div class="value">{{datailsData.deviceId}}</div>
          </li>
          <li>
            <div class="label">IMEI:</div>
            <div class="value">{{datailsData.imei}}</div>
          </li>
          <!-- <li>
            <div class="label">设备注册至:</div>
            <div class="value">{{datailsData.registTo == 0 ? 'XY' : datailsData.registTo == 1 ? 'LT' : datailsData.registTo == 2 ? 'DX' : datailsData.registTo == 4 ? 'YD' : '其他'}}</div>
          </li> -->
          <li v-if="datailsData.registTo==0">
            <div class="label">X设备ID:</div>
            <div class="value">{{datailsData.termId}}</div>
          </li>
          <li v-if="datailsData.registTo==0">
            <div class="label">X设备标识:</div>
            <div class="value">{{datailsData.termCode}}</div>
          </li>
          <li v-if="datailsData.registTo==1">
            <div class="label">L设备ID:</div>
            <div class="value">{{datailsData.unicomIotId}}</div>
          </li>
          <li v-if="datailsData.registTo==1">
            <div class="label">L设备Key:</div>
            <div class="value">{{datailsData.unicomDeviceKey}}</div>
          </li>
          <li>
            <div class="label">是否注册:</div>
            <div class="value">{{datailsData.isRegist?'已注册':'未注册'}}</div>
          </li>
          <li v-if="!datailsData.isRegist">
            <div class="label">注册失败:</div>
            <div class="value">{{datailsData.registErrMsg}}</div>
          </li>
          <li>
            <div class="label">是否安装:</div>
            <div class="value">{{datailsData.isInstall?'已安装':'未安装'}}</div>
          </li>
          <li>
            <div class="label">是否报警:</div>
            <div class="value">{{datailsData.isAlarm?'报警':'未报警'}}</div>
          </li>
          <li>
            <div class="label">是否故障:</div>
            <div class="value">{{datailsData.isFault?'已故障':'未故障'}}</div>
          </li>
          <li>
            <div class="label">是否启用:</div>
            <div class="value">{{datailsData.isEnabled?'已启用':'未启用'}}</div>
          </li>
          <li>
            <div class="label">是否在线:</div>
            <div class="value">{{datailsData.isOnline?'在线':'离线'}}</div>
          </li>
          <li>
            <div class="label">通知人员类型:</div>
            <div class="value">{{datailsData.noticeUserType==1?'通知安装人':datailsData.noticeUserType==2?'通知负责人':datailsData.noticeUserType==3?'通知安装人和负责人': datailsData.noticeUserType==4?'通知使用人' : '通知负责人和使用人'}}</div>
          </li>
          <li>
            <div class="label">使用人:</div>
            <div class="value">{{datailsData.userTel?datailsData.userTel:'无'}}</div>
          </li>
          <li>
            <div class="label">通信协议方式:</div>
            <div class="value">{{datailsData.protocol==0 ? 'MQTT' : (datailsData.protocol==1 ? "NB" :(datailsData.protocol==2 ? "HTTP" :(datailsData.protocol==3 ? "TCP" : '未知')))}}</div>
          </li>
          <li>
            <div class="label">启用方式:</div>
            <div class="value">{{datailsData.isEnabled?'启用':'禁用'}}</div>
          </li>
          <li>
            <div class="label">安装位置:</div>
            <div class="value">{{datailsData.installLocation}}</div>
          </li>
          <li>
            <div class="label">入库时间:</div>
            <div class="value">{{datailsData.createTime}}</div>
          </li>
          <li>
            <div class="label">注册时间:</div>
            <div class="value">{{datailsData.registTime}}</div>
          </li>
          <li>
            <div class="label">安装时间:</div>
            <div class="value">{{datailsData.installTime}}</div>
          </li>
          <!-- <li>
                  <div class="label">使用者:</div>
                  <div class="value">{{datailsData.userName}}</div>
               </li>
               <li>
                  <div class="label">使用者联系方式:</div>
                  <div class="value">{{datailsData.userTel}}</div>
               </li> -->
          <li>
            <div class="label">安装区域</div>
            <div class="value" v-if="datailsData.region">{{ datailsData.region.name }}</div>
          </li>
          <li>
            <div class="label">负责人、联系方式:</div>
            <div class="value" v-if="datailsData.region">
              <div v-for="(item,index) in datailsData.region.chargePersonList" :key="index" style="lineHeight:24px;">
                <span>{{item.nickName}}</span><span>（{{item.tel}}）</span>
              </div>
            </div>
          </li>
          <li>
            <div class="label">安装人员:</div>
            <div class="value">{{datailsData.installUserName}}</div>
          </li>
          <li>
            <div class="label">安装人员联系方式:</div>
            <div class="value">{{datailsData.installUserTel}}</div>
          </li>
          <li>
            <div class="label">设备类型名称:</div>
            <div class="value">{{datailsData.deviceTypeName}}</div>
          </li>
          <li>
            <div class="label">设备种类:</div>
            <div class="value">{{datailsData.deviceType}}</div>
          </li>
          <li>
            <!-- v-if="urlData != '无此图片'" -->
            <div class="label">现场图片:</div>
            <div class="value1">
              <div>
                <div v-show="addShowImgs" v-for="(url, index) in urlData" :key="index">
                  <img :src="`${baseUrlAddr}/front/device/deviceImg/download?fileName=${url}`" alt="" @click="handleOpenBigUrl(url)">
                  <div class="close" v-if="closeShow" @click="handleClose(url)">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
                <div v-if="addShowImg">
                  <el-upload
                  class='upload-demo'
                  action
                  :limit='5'
                  list-type='picture-card'
                  :on-remove='handleRemove'
                  :file-list='fileList'
                  :http-request='handleHttpRequest'
                  :before-upload='beforeAvatarUpload'
                  :on-change='handleSomeimg'
                  >
                    <i class='el-icon-plus'></i>
                  </el-upload>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="bigUrl">
      <el-dialog
        title="现场图片"
        :visible.sync="dialogVisibles"
        width="30%"
        >
        <div>
           <img :src="`${baseUrlAddr}/front/device/deviceImg/download?fileName=${bigUrl}`" alt="">
           <!-- <img src="../../assets/img/login/bigErweima.png" alt=""> -->
        </div>
      </el-dialog>
    </div>
  </div>
  <div class="sub">
    <el-button type="primary" @click="handleEdit" v-if="showEnitBtn">编辑图片</el-button>
    <el-button type="primary" @click="handleSubImg" v-else :loading="logining">完成</el-button>
  </div>
</div>
</template>

<script>
export default {
  props: {
    datailsData: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      dialogVisibles: false,
      dialogVisibleBigImg: false,
      addShowImgs: true,
      dialogImageUrl: '',
      urlList: [],
      bigUrl: '',
      fileList: [],
      file: [],
      urlData: [],
      addShowImg: false,
      showEnitBtn: true,
      closeShow: false,
      logining: false,
      imgId: '',
    };
  },
  watch: {
    datailsData(newV) {
      console.log(newV);
    }
  },
  created() {
    this.handleInfoImg()
  },
  mounted() {

  },
  methods: {
    // 初始化图片
    handleInfoImg () {
      this.request.get(`/front/device/deviceImg/${this.datailsData.id}`).then(res => {
        if (res.code == 200) {
          this.urlData = res.data
          // console.log(888, this.urlData);
          if (this.urlData == '无此图片') {
            this.addShowImgs = false
            this.file = []
          } else {
            this.imgId = this.urlData.id
            let arr = this.urlData.deviceImg.split(';')
            let arr1 = []
            arr.forEach(url => {
              if (url == '') {
                console.log(url)
              } else {
                arr1.push(url)
              }
            })
            this.urlData = arr1
            this.addShowImgs = true
            this.urlData.forEach(data => {
              this.file.push(data)
                this.request.get(`/front/device/deviceImg/download?fileName=${data}`).then(res => {
                  if (res.code == 200) {
                    console.log(77777, res.data)
                  }
              })
            })
          }
        }
      })
    },
    handleOpenBigUrl (url) {
      this.dialogVisibles = true
      this.bigUrl = url
    },
    // 上传图片========================================================
    handleHttpRequest (obj) {
      this.handleSub()
    },
    handleSomeimg (file, fileList) {
      this.fileList = fileList
    },
    handleSub () {
      // console.log('ad',this.fileList)
      // console.log('addad',this.fileList)
      let formData = new FormData()
      formData.append('file', this.fileList[this.fileList.length - 1].raw)

      this.request.post('/front/device/deviceImg/upload', formData).then((res) => {
        if (res.code != 200) return
        this.msg.success('上传成功')
        console.log('上传', res)
        const files = res.data
        this.file.push(files)
        console.log('push信息', this.file)
      })
    },
    beforeAvatarUpload (file) {
      console.log(11111, file)
      const isJPG = file.type === 'image/jpeg'
      const isJPG2 = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 10
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning('只支持jpeg或jpg或png格式图片')
      }
      if (!isLt5M) {
        this.$message.warning('请上传10MB以内的图片!')
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M
    },
    handleRemove (file, fileList) {
      let fileID = file.uid
      // console.log('file', file)
      // console.log('fileList', fileList)
      this.fileList = fileList.filter((val) => {
        return val.uid != fileID
      })
      this.file = this.fileList
    },
    // 提交图片
    handleSubImg () {
      this.logining = true;
      let par = {
        deviceId: this.datailsData.id,
        imei: this.datailsData.imei,
        imgNames: this.file,
      }
      this.request.post('/front/device/deviceImg/save',par).then(res => {
        if (res.code == 200) {
          this.msg.success('保存成功')
          this.showEnitBtn = true
          this.addShowImg = false
          this.fileList = []
          this.file = []
          this.handleInfoImg()
          this.closeShow = false
          this.logining = false;
        } else {
          this.msg.error(res.msg)
        }
      })
    },
    // 点击编辑
    handleEdit () {
      this.closeShow = true
      if (this.urlData.length >= 5) {
        this.addShowImg = false
        this.showEnitBtn = false
        this.msg.warn('最多上传5张图片')
      } else {
        this.addShowImg = true
        this.showEnitBtn = false
      }
    },
    // 删除
    handleClose (data) {
      let par = {
        id: this.imgId,
        imageName: data
      }
      this.request.post('/front/device/delDeviceImg', par).then(res => {
        if (res.code == 200) {
          this.msg.success(res.msg)
          this.fileList = []
          this.file = []
          this.handleInfoImg()
          console.log(this.file);
        } else {
          this.msg.error(res.msg)
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.detailsDrawerBody {
  padding: 10px 35px;
  .detailsItem {
    padding-left: 20px;
    h4 {
      font-size: 16px;
      color: #333;
      line-height: 38px;
      font-weight: bold;
      border-bottom: 1px solid #aaa;
    }
    .details {
      padding: 10px 0;
      ul {
        li {
          line-height: 38px;
          .label {
            display: inline-block;
            vertical-align: middle;
            color: #bbb;
            width: 150px;
          }
          .value {
            display: inline-block;
            // vertical-align: middle;
            color: #888;
            margin-left: 5px;
            .unit {
              margin-left: 10px;
            }
          }
          .value1 {
            display: inline-block;
            width: 65%;
            // vertical-align: middle;
            color: #888;
            margin-left: 5px;
            >div {
              display: flex;
              flex-flow: row wrap;
              .upload-demo {
                /deep/.el-upload-list {
                  .el-upload-list__item {
                    width: 80px;
                    height: 80px;
                    .el-upload-list__item-actions {
                      display: none !important;
                    }
                  }
                }
                /deep/.el-upload {
                  width: 80px;
                  height: 80px;
                  line-height: 80px;
                  vertical-align: middle;
                }
              }
              >div {
                margin-right: 10px;
                margin-bottom: 10px;
                position: relative;
                img {
                  cursor: pointer;
                  width: 80px;
                  height: 80px;
                }
                .close {
                  position: absolute;
                  top: -18px;
                  right: -5px;
                  cursor: pointer;
                }
              } 
            }
          }
        }
      }
      .btn {
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -20px;
      }
    }
    &.params {
      .details {
        padding-right: 100px;
        position: relative;
      }
    }
  }
  .bigUrl {
    /deep/.el-dialog__wrapper {
      .el-dialog {
        .el-dialog__body {
          div {
            width: 100%;
            height: 100%;
            text-align: center;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
.sub {
  text-align: center;
  height: 60px;
  line-height: 60px;
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #fff;
}
</style>
